import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { debounceTime, map, of, switchMap, tap } from "rxjs";
import { CabinetService } from "src/app/cabinet/services/cabinet.service";
import { IBaseGetByComanyRequest } from "src/app/core/models/base";
import { debug, RxJsLoggingLevel } from "../rxjs-operators/debug-operator";

export function CabinetValidator(cabinetService: CabinetService, companyId: string, originalName: string, originalCabinetId?: string): AsyncValidatorFn {
    return  (control: AbstractControl) => {

        // skip validation if no changes
        if (control.value === originalName) {
            return of(null);
        }

        const request : IBaseGetByComanyRequest= {
            pageNumber:0,
            pageSize: 999999,
            companyId: companyId,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'name',
                        operator: 'eq',
                        value: control.value
                    }
                ]
            }
        }


        return of(request).pipe(
            debounceTime(1000),
            switchMap(request => {
                return cabinetService.getCabinetsByCompany(request)
            }),
            map(response => {
                const cabinets = response.data;

                // Filter own cabinet by id if provided
                const duplicates = originalCabinetId
                  ? cabinets.filter(cabinet => cabinet.id !== originalCabinetId)
                  : cabinets;

                return duplicates.length !== 0
                    ? { nameIsNotUnique: true }
                    : null;         
            })
        )
    }
}